import {
  add2suhfggl4zvkk as add,
  multiply2k9eolhnz1bjv as multiply,
  dividelr0uqtdj497z as divide,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { ArithmeticException18dajwq7kbp38 as ArithmeticException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function safeAdd(a, b) {
  var sum = add(a, b);
  if ((a ^ sum) < 0n && (a ^ b) >= 0n) {
    throw ArithmeticException().new_kotlin_ArithmeticException_y2sjkx_k$('Addition overflows a long: ' + a.toString() + ' + ' + b.toString());
  }
  return sum;
}
function safeMultiply(a, b) {
  if (b === 1n) {
    return a;
  }
  if (a === 1n) {
    return b;
  }
  if (a === 0n || b === 0n) {
    return 0n;
  }
  var total = multiply(a, b);
  if (!(divide(total, b) === a) || (a === -9223372036854775808n && b === -1n) || (b === -9223372036854775808n && a === -1n)) {
    throw ArithmeticException().new_kotlin_ArithmeticException_y2sjkx_k$('Multiplication overflows a long: ' + a.toString() + ' * ' + b.toString());
  }
  return total;
}
function safeMultiply_0(a, b) {
  var total = multiply(fromInt(a), fromInt(b));
  if (total < -2147483648n || total > 2147483647n) {
    throw ArithmeticException().new_kotlin_ArithmeticException_y2sjkx_k$('Multiplication overflows an int: ' + a + ' * ' + b);
  }
  return convertToInt(total);
}
//region block: exports
export {
  safeAdd as safeAdd2ojtf0puot5k0,
  safeMultiply as safeMultiply1xb0xo3cufzd3,
  safeMultiply_0 as safeMultiplyomi65rg5l1en,
};
//endregion

//# sourceMappingURL=mathNative.mjs.map
